import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { Redirect } from "react-router-dom";

import { sendSecurePinToDevice } from "../actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { replaceHashValues } from "utils/replaceHashValues";
import { media, isMobile } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";

import ReactButton from "common-components/Buttons";
import { ButtonGroup } from "@vds/buttons";
import { TitleLockup } from "@vds/type-lockups";
import { Body } from "@vds/typography";
import AlertBanner from "common-components/Alert";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import CommonContainer from "common-components/Container";
import CommonHeader from "common-components/Header";

class MultifactorAuthenticationPrimer extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Multifactor Authentication Primer", this.props.pageContent.sc_pagetitle);
    }
  }

  handleClick = () => {
    this.props.sendSecurePinToDevice().then(() => {
      if (!this.props.error) {
        this.props.history.replace("multifactor-authentication", {
          ...this.props.location.state
        });
      }
    });
  };

  render() {
    const { pageContent, loading } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    if (loading) {
      return <RectangleLoader />;
    }

    return (
      <Fragment>
        {this.props.error ? (
          <AlertBanner alertType="error" disableAnimation>
            {convertStringToElements(this.props.error)}
          </AlertBanner>
        ) : null}
        <Container>
        <TitleLockup 
            surface='light'
            textAlignment='left'
            data={{
              title:{
                size: 'titleXLarge',
                bold:false,
                children: convertStringToElements(pageContent.section_title)
              },
              subtitle:{
                size: 'bodyLarge',
                children: 
                <BodyContainer>
                  <Body size='large'>
                    {convertStringToElements(
                     replaceHashValues(pageContent.categories[0].category_description, {
                        selectedMDN:
                        checkAMLob() === "agent"
                        ? window.reactGlobals.agentInfo.agentEmailId
                        : this.props.verifiedDevice
                    })
                    )}
                    </Body>
                </BodyContainer>

              }

          }}
          
          
          />
        
          <ButtonGroup
              childWidth={'100%'}
              viewport={isMobile ? 'mobile' : 'desktop'}
              rowQuantity={{ desktop: 2 , mobile: 1}}
              data={[
                  {
                    children: <span style={{fontFamily:'Verizon-NHG-eDS, Helvetica, Arial, sans-serif'}}>{pageContent.buttons[0].text}</span>,
                    size: 'large',
                    ariaLabel: pageContent.buttons[0].text,
                    use: pageContent.buttons[0].type === "white_background" ? 'secondary' : 'primary',
                    width: isMobile ? '100%' : 'auto',
                    onClick:() => this.handleClick()
                  },
                  ...( !window.reactGlobals.isAllMdnDisconnected &&
                    this.props.deviceListLength > 1 &&
                    !this.props.location.state.hasOwnProperty("showDownloadModal") &&
                    !this.props.location.state.hasOwnProperty("hideChangeDeviceButton") &&
                    !this.props.location.state.hasOwnProperty("resendPWFlow") ?
                  [{
                    children: pageContent.links[0].text,
                    ariaLabel: pageContent.links[0].text,
                    size: 'large',
                    use: "textLink",
                    width:  isMobile ? '100%' : 'auto',
                    onClick: () => this.props.history.goBack(),
                  },
                  ]
                  : []
                ) , 
                ]}
              alignment={isMobile ? 'center' : 'left'}

          />
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  pageContent,
  loadingAndErrorState,
  verifiedSecurePinDevice,
  profileInformation
}) => ({
  pageContent: pageContent.multifactor_authentication_primer,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  verifiedDevice: verifiedSecurePinDevice.verifiedDevice,
  deviceListLength: profileInformation.length
});

export default connect(
  mapStateToProps,
  { sendSecurePinToDevice, setA11yContent }
)(MultifactorAuthenticationPrimer);

const Button = styled(ReactButton)`
  margin-right: 28px;

  ${media.mobile`
    margin-right: 0;
  `}
`;


const ButtonLink = styled.button`
  background: 0;
  border: 0;
  font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
  text-decoration: underline;
  cursor: pointer;

  ${media.mobile`
    display: block;
    margin: 10px auto;
  `}
`;

const Header = styled(CommonHeader)`
  max-width: 615px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 16px;
  font-family:'Verizon NHG DS';
  font-weight: 400;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS';
`}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
     margin: 0;
    padding: 32px 16px ;
  `}
`;


const BodyContainer = styled.p`
  max-width: 600px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  margin-bottom: 48px;
  ${media.mobile`
  max-width: 100%;
  font-family: Verizon NHG eTX, Helvetica, Arial, sans-serif;;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  `};
`;